import { RelyingPartiesState } from "@idw-types/state/relying-parties-state";
import { getRelyingPartiesState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getRelyingPartiesDataState = createSelector(getRelyingPartiesState, (state: RelyingPartiesState) => {
    return {
        isLoadingRelyingParties: state.relyingParties.isLoading,
        relyingParties: state.relyingParties.relyingParties
    }
});